module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Chapter One")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("REVIVAL FOR THE REST OF US")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("A revival, then, really means days of heaven upon earth.")])]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTYN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOYD-")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONES")]), _vm._v(", "), _c('i', [_vm._v("R")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("EVIVAL")])])])]), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("Will you not revive us again, that your people may rejoice in you?")])]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONS OF")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORAH")]), _vm._v(", P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 85:6")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("W")]), _vm._v("hile he was in college, a friend of ours, Sam, once passed up an offer to go out for dinner. The father of one of his roommates was in town and offered to take the entire apartment out for dinner, but Sam was tired from a long day. While he declined, his other roommate, Jerome, didn’t miss a beat taking up the offer.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When Jerome returned, he said to Sam, “You won’t believe where we went to eat!”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Where’d you go?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“To the most extravagant restaurant I’ve ever been to.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Then he began to describe his meal: S.Pellegrino, not water. Two different appetizers. Then, lobster. Steak. Duck. The best wine. Chocolate dessert. And, they had their own dedicated waiter throughout the meal. Total cost? $450 for four, even when the restaurant had thrown in the appetizers.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("And, of course, his roommate’s dad had covered the bill.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Sam had one definition of dinner in his mind, but dinner turned out to be something far better than he had imagined.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What if it’s like that with the word "), _c('i', [_vm._v("revival  ")]), _vm._v("? What if we’re turning down “dinner” before finding out what revival truly is?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So before judgments are cast, let’s define revival.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Defining Revival")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Not only does revival have a wide range of definitions, it is also one of several terms describing similar spiritual dynamics—such as renewal and awakening. Although some may make distinctions between these three terms, we don’t. Richard Lovelace, a scholar on evangelical revival, offered the same conclusion: “Renewal, revival and awakening"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-019",
      "id": "ap_ntf-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" trace back to biblical metaphors for the infusion of spiritual life in Christian experience by the Holy Spirit. Usually they are used synonymously.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So what is revival?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The first set of definitions we found is clustered around personal or corporate reinvigoration of our spiritual experience. Charles Finney, a minister and leader in the Second Great Awakening, defined revival as “a renewed conviction"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" of sin and repentance, followed by an intense desire to live in obedience to God.” Mid-twentieth-century British pastor Martyn Lloyd-Jones described it as “a period of unusual blessing"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-021",
      "id": "ap_ntf-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" and activity in the life of the Christian Church.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What they all are saying in so many words is this: in revivals, faith becomes “white-hot.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-022",
      "id": "ap_ntf-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" And although we liked these definitions as far as they went, we yearned to include more specifics about how revival would be expressed and how it might spill over to those who don’t identify as Christian.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Others add more specifics to their definitions. In his book, "), _c('i', [_vm._v("Revivals: Their Laws and Leaders")]), _vm._v(", James Burns highlights the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("amount of people involved: “Large numbers of persons"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-023",
      "id": "ap_ntf-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" who have been dead or indifferent to spiritual realities then become intensely awakened to them.” Pastor Tim Keller offered one along the same lines: “A season in which"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" a whole body of believers experience gospel renewal together.” Lovelace adds a missional element: “Broad-scale movements"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-025",
      "id": "ap_ntf-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" of the Holy Spirit’s work in renewing spiritual vitality in the church and in fostering its expansion in mission and evangelism.” Author Mark Shaw adds a societal effect to his definition: “Global revivals are charismatic people movements"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-026",
      "id": "ap_ntf-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" that transform their world by translating Christian truth and transferring power.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We liked these additions as well but wanted to see them come together in a single definition. But I’d like to pause here and ask, Whatever misgivings you might have about the word "), _c('i', [_vm._v("revival")]), _vm._v(", if you saw these characteristics or marks of revival in your faith communities, wouldn’t you welcome them?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But yes, the range of definitions can make your eyes swim.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That led us down a path to find a more accessible definition of revival"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-027",
      "id": "ap_ntf-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(". Could we capture a similar range of definitions in a simpler way, while also coming up with something that could be welcomed by more faith communities?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Could we define revival for the rest of us?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So we researched what revival looked like in history, learned from its dynamics, prayed about it, and attempted to tackle a definition that might be helpful to our movement. After nine months, we landed on a definition for revival:")]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("A season of breakthroughs")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("in word, deed, and power")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("that ushers in a new normal")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("of kingdom experience and fruitfulness")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Let’s unpack it.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A Season of Breakthroughs")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The first line, “a season of breakthroughs,” avoids defining revival by a singular event. We say breakthrough"), _c('i', [_vm._v("s")]), _vm._v(", not breakthrough. If revival could include any one-off experience, then it’s not very useful as a term. For example, let’s say I just had a powerful experience with God last night. Should that be considered revival? We didn’t want a definition that could too easily speak of any single spiritual experience.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The implications are enormous. For example, the day of Pentecost—on its own—would not be considered a revival. Wait, what? Yes, the Holy Spirit surely swept through the community of believers, and three thousand people and their families were baptized into the Christian faith. Still, we wouldn’t consider that revival.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Not yet.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But in Acts 2:42-47, Pentecost marks the beginning of a fledgling faith community that starts to have its own set of rhythms setting it apart. It has moved beyond a moment to a movement. It’s beginning to become a revival at that point.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Then, add an Acts 3 healing, an Acts 4 filling of the Holy Spirit, an Acts 5 supernatural intervention of discipline, and an Acts 6 move of justice to empower ethnic minorities—and the revival is growing. The whole book of Acts describes revival.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It wasn’t just one breakthrough but a season of breakthroughs. And it doesn’t last forever. That’s also important. It’s a “season.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Consider it as nature’s rhythm. Springtime comes after winter, fall after summer. There’s a blossoming, then a retreat. In the same way, throughout history, revivals ended. They came for a limited time—sometimes for three months and other times for three decades—but when they came, God broke through long enough to create a new normal.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("Also, the boundaries between seasons aren’t always rigid; they can be fuzzy. In the throes of winter, spring already has its seeds in place. Potential lies dormant under the snow, ready to break through. When spring starts to arrive, a few sunny days surprise us. A warm gentle breeze carries the first scents of new life. But it can retreat, and winter delays spring’s full bloom.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It’s that kind of peekaboo experience that can capture these seasons of spiritual awakening. At first, the signs can be shy and fickle, but they eventually grow stronger and more consistent like the rising temperatures and longer days. Soon enough, we find ourselves in the embrace of a new season that sweeps us up into its characteristic joys and wonders.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But even with their ebbs and flows, revivals, when added up, “are at the heart"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-028",
      "id": "ap_ntf-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" of the global resurgence of Christianity.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("With just one line of our definition, we change the quality of revival that we seek.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We don’t just seek a single breakthrough but a season of breakthroughs.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("In Word, Deed, and Power"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-029",
      "id": "ap_ntf-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If the first line of our definition expands the length of revival, the second line expands its breadth. These breakthroughs happen “in word, deed, and power.” The idea comes from Paul himself in his letter to the Romans. In chapter 15, he offers a summary of his ministry:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Therefore I glory in Christ Jesus"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-030",
      "id": "ap_ntf-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" in my service to God. I will not venture to speak of anything except what Christ has accomplished through me in leading the Gentiles to obey God by what I have "), _c('i', [_vm._v("said")]), _vm._v(" and "), _c('i', [_vm._v("done")]), _vm._v("—by the "), _c('i', [_vm._v("power")]), _vm._v(" of signs and wonders, through the "), _c('i', [_vm._v("power")]), _vm._v(" of the Spirit of God. So from Jerusalem all the way"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-031",
      "id": "ap_ntf-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" around to Illyricum, I have "), _c('i', [_vm._v("fully proclaimed")]), _vm._v(" the gospel of Christ.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("How can Paul claim that he “fully proclaimed” the gospel of Christ? What did he mean? A few interpretations exist, and the most likely way to read this is that he fulfilled his mandate to plant strategic churches in the region described “from Jerusalem all the way around to Illyricum.”")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-001"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 1. The full proclamation of the gospel",
      "src": "images/fig_1.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 1.")]), _vm._v(" The full proclamation of the gospel")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But “fully proclaimed” could also point to the nature of his proclamation. A Greek lexicon offers this definition: “to relate fully"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-032",
      "id": "ap_ntf-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" the content of a message.” And in this passage, one way that he fully proclaimed the gospel was through word, deed, and power.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("By word, we mean"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-033",
      "id": "ap_ntf-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" the expression of the gospel through biblical teaching and preaching. By deed, we mean the expression of the gospel in compassion and justice. By power, we mean the expression of the gospel in miraculous or explicitly supernatural ways.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But how many faith communities can claim to fully express word, deed, and power? Most offer one. Fewer offer two. But all three?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yet mature Christian revivals often had all three.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It’s easy to see how having only one of these three expressions of the gospel can stunt revival in our hearts and communities. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("Word without deed or power could potentially lead to a privatized kind of faith or a dead legalism. A breakthrough in deed without word or power could become a social justice cause without explaining the source of hope or knowing the sense of its power. A breakthrough in power without word or deed can press into an excessive show of emotionalism or an unhealthy hunger for a heavenly experience that does no earthly good"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-034",
      "id": "ap_ntf-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When these three come together in love, however, they have a way of keeping a healthy balance between the expressions of the Christian gospel.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But what often happens is that the word-centered folks denigrate deed-centered folks, thinking that they do good works but don’t have theological grounding, and also look down on the power-centered folks as people who chase experiences without being rooted in the Word. And deed-centered folks may judge word-centered folks as pandering to dead orthodoxy while wondering when the power-centered folks will stop chasing an otherworldly, spiritual high and start seeking justice. Power-centered folks wonder if the word-centered folks are guilty of “having a form of godliness but denying its power"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-035",
      "id": "ap_ntf-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(",” while believing that the deed-centered folks are burnt out and angry because they don’t tap into the life of the Spirit.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What was meant to work together, we often pull apart.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("By holding these three jointly, there is room for all in revival. And in fact, we believe all are needed for revival to reach its full capacity.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Of course, all of these circles don’t have to play out at the first flush of revival. Historically, revival can come through any one of these circles.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The First Great Awakening came primarily through the word circle, where John Wesley preached to miners and taught the Methodists to seek greater holiness through the support of Christian community. At the turn of the thirteenth century, the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("Franciscans started out primarily through the deed circle, as their founder, Francis of Assisi, cared for lepers and embraced voluntary poverty. The Pentecostal movement at the turn of the twentieth century came primarily through the power circle, as the Holy Spirit fell on a multiracial community at Azusa Street.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But as revivals mature, they start taking on the other values. The Methodists started as Bible teachers and preachers, but they would be open to power as manifestations of the Holy Spirit would disrupt Wesley’s meetings, and they moved into deed with their concern for the poor and lower classes. Although known for their vows of poverty, the Franciscans leaned into the word circle through communal Bible studies and preaching the gospel throughout the world, and the power circle would be expressed through mystical experiences of such ecstasy that they “lay on the ground like dead men"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-036",
      "id": "ap_ntf-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(".” The Pentecostal movement, as it grew"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-037",
      "id": "ap_ntf-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(", preached to a packed house daily on Azusa Street, pressing further into word, and quickly moved into the deed circle as people from different ethnic, gender, and class groups were empowered together.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Revivals, as they mature, move toward the center.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("They exhibit word, deed, and power in love.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In 1929, Ugandan healthcare worker Simeoni Nsibambi met with a burned-out British doctor and missionary, Joe Church, to seek God for a fresh infusion of the Spirit. After two days of intense Bible study and prayer, they experienced what they referred to as “a share in the power of Pentecost"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-038",
      "id": "ap_ntf-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(".” For the next four decades, the East African revival poured all the way down to South Africa, and then over to other continents. The word and power revival expressed deed when African Christian leaders and European missionaries publicly confessed racial pride and invited others to do the same at their gatherings. One African attendee said, “I have never before seen"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-039",
      "id": "ap_ntf-039-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" any white man admit he had any sins.” Those touched by this revival"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-040",
      "id": "ap_ntf-040-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" actively promoted justice, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("fought corruption, and elevated Christian ethics over tribal loyalty, some paying for these outspoken views with their lives.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("The power circle and the Holy Spirit.")])]), _vm._v(" InterVarsity Christian Fellowship USA, as an evangelical organization, has a large word circle (see "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#fig-001"
    }
  }, [_vm._v("figure 1")]), _vm._v("). We use manuscript Bible study"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-041",
      "id": "ap_ntf-041-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" from our smallest to largest gatherings, where we pull out colored pencils to mark up our copy of the Scripture passage, making careful observations, asking rigorous questions, and interpreting the text to find genuine applications. It’s one of the best things we do.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Our deed circle is more medium-sized. Our students spend their spring breaks to serve in projects like ServeUp in the aftermath of Hurricanes Katrina and Harvey, and we include students and faculty of every ethnicity and culture. Our history is rich with stories of our staff championing racially integrated Bible studies and camps in the ’40s, a decade before the civil rights movement began. And our alumni have done amazing things"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-042",
      "id": "ap_ntf-042-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" for the common good, such as leading an organization that serves prisoners and their families and starting a movement that fights slavery and injustice all around the world.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But, in full confession, our power circle is small. We have pockets of staff and students who are open to the Holy Spirit moving in power, and we’re growing in it. But, it’s still not that widespread.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If mature revivals reflect all three circles in harmony and balance, then our movement needs to be more open to the power of God’s Spirit. We wonder if that’s generally true for many Western believers. And as we look back in history, the revival landscape was often flooded with an openness to the Holy Spirit—whether in intimacy or miraculous power.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And we’re aware that there have been spiritual excesses and abuses in the name of the Holy Spirit. You may have personally witnessed or experienced some of them, causing you great harm "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("and pain. We don’t minimize the trauma that many have experienced. As we move forward, we must continually check and balance our power experiences with word and deed.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Still, the Scriptures say, “Do not quench the Spirit"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-043",
      "id": "ap_ntf-043-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(".”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To prepare ourselves for revival, we’ll need leaders who see the desire for greater intimacy with the Spirit as a sign of awakening bubbling up in a generation desiring more of God and who resist the temptation to respond with a knee-jerk reaction against the Sprit, fueled by fear of all that could go wrong. They could offer wise, biblical, experienced, grounded, and courageous mentoring so that a new move of God can be birthed.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Could we be more like the Bereans in Acts 17:11, who “received the message with great eagerness and examined the Scriptures every day to see if what Paul said was true”? As you read on, you might read something that pushes your comfort zone a bit. And while you test what we write through the lens of Scripture, would you consider having an open heart and mind to what the Spirit might say?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Love is at the center.")])]), _vm._v(" And one more caveat: all of this—word, deed, and power—needs to operate in love. It’s almost too obvious to be stated, and for that reason we didn’t include it in the definition. But still, we didn’t want you to miss it. The Scriptures warn us that anything done without love is worthless. First Corinthians 13 explains this well through word, deed, and power:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("If I speak in the tongues of men or of angels [power], but do not have love, I am only a resounding gong or a clanging cymbal. If I have the gift of prophecy and can fathom all mysteries and all knowledge [word and power], and if I have a faith that can move mountains, but do not have love, I am nothing. If I give all I possess to the poor and give over my body to hardship that I may boast [deed], but do not have love, I gain nothing.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("It’s actually easy to exercise word, deed, and power without love. We can preach the text rightly but have little care for our audience. We could lead protests against injustices but hate our oppressors. We might pray for miracles but do it for our own glory. And if we do, word, deed, and power become dangerous and abusive.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Our gifts are most powerful and effective, however, when expressed through love, because that is who God is.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("That Ushers In a New Normal")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The third line of our definition highlights the result of revivals: “That ushers in a new normal.” These breakthroughs aren’t merely about the experience, but they should create a new expectancy of what God can do in us, through us, and around us.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Imagine being part of a faith community where it’s rare to have someone decide to follow Jesus for the first time. It’s like spotting an endangered species: “See the new Christian grazing in the savannah . . .” But then, something changes, and families start to get baptized to mark the start of their newfound faith every three months or so. That changes expectations. It becomes a new normal to have families come to faith every once in a while. And because that happens, it doesn’t seem impossible to think of someone coming to faith every month. In fact, it would be disappointing if the community went back to seeing no one come to faith anymore.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It’s a new normal.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This may be the most important piece of the definition: revivals should create a new normal. They weren’t given so that we can just go back to the way things were. They were given so that our faith can have capacity for more, to hope for more, to seek more of God’s kingdom.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Back in 2001, I (Ryan) stood in front of over a hundred students for our weekly InterVarsity worship gathering at the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("University of California, San Diego. At the end of a message about Jesus’ love for lost people, I asked a simple question: “How many of you have ever seen a friend come to faith and have been a part of that process?”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The room went dead silent.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After an awkward ten seconds, three students sheepishly raised their hands. Only three. The dots connected before my eyes: virtually no one had ever seen it happen. We might as well have been asking students to pray for the dead to rise. It was no surprise—at that point in the fall semester, no one had come to faith through our community.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So, I pulled together a small team of campus ministers, and the three of us would encourage and equip students to lead their friends to Jesus. We prayed, we taught, and we modeled. By the end of that academic year, by God’s grace, 28 students started to follow Jesus!")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Emboldened, the following year we began praying for 100 students to come to faith. It was crazy: only one campus in our sixty-year history as a national movement had ever seen more than 100 students come to faith in a year, and that one had Billy Graham preaching on campus. Yet with a new normal, we grew in confidence that God could use students to make a significant impact on our campus—even without Billy Graham!")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Two years later, we saw 104 students come to faith through UCSD InterVarsity in a single year. The following year: 107 students. When I asked again how many people had been part of helping a friend come to faith, over half the students in the room raised a hand. A palpable faith had energized the community with newfound purpose and joy.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After one of our weekly gatherings where fifteen students had stood to dedicate their lives to following Jesus, a freshman excitedly told me, “It feels like every week we are having a revival. I "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("used to only feel that when I went to a Christian camp, but it would fade as soon as I got home. Here, it’s like it never fades. It just keeps going from week to week!”")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Of Kingdom Experience and Fruitfulness")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We round out our definition with the fourth line, which describes the dimensions of revival: “of kingdom experience and fruitfulness.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It’s in and out. It’s internal and external.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Our souls may be revived, but that should spill over into mission. It bears fruit. It’s not just for us, but the revival was also meant for all around us. It’s not just meant to connect with individual souls, but true revival also brings a change in our relationships, in our communities, and in our societies.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It breaks out into the world.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It really has to create a new normal, not only in us but around us: a new normal that is good and just.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And it’s also personal. Some may take issue with our insistence that revival could actually be located in an individual’s experience. Didn’t we just spend a lot of time trying to say that revivals aren’t just a blip on the screen, not just a one-time event? Yes, we still hold to that. They are not moments, but movements, and yet they often start in someone’s soul.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Seminary professors Malcolm McDow and Alvin Reid put it this way: “Revivals always start"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-044",
      "id": "ap_ntf-044-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" with personal encounters with God and travel through concentric circles to their conclusions. . . . Revival always starts with that one or those few who are serious with God, are ignited by God, and who become flames from which others can be set afire.” It’s such a pattern that we can be confident enough to say this: no revival in history started without revived people. In a very real sense, revival starts within someone or a within a group of people.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Early twentieth century evangelist Rodney “Gypsy” Smith was once asked how to start a revival. He replied, “Go home. Lock "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("yourself in your room"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-045",
      "id": "ap_ntf-045-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(". Kneel down in the middle of the floor, and with a piece of chalk draw a circle around yourself. There, on your knees, pray fervently and brokenly that God would start a revival within that chalk circle.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We can’t ignore the personal experience of revival. It’s a seed. It begins small and unnoticed in the soil of a desperate heart, but can also escalate into a people movement that spreads its branches broadly enough so that communities and even nations may find refuge in them.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Levels of Revival")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Revivals can be like earthquakes. With the seismograph, scientists can both detect and measure an earthquake. But not all earthquakes are the same. We live in Southern California, so unfortunately, we know earthquakes. Some shake while others roll. Some feel like a sudden drop while others swish around a bit. To measure an earthquake’s magnitude, scientists use the Richter scale.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What’s interesting about the Richter scale is that no matter where the tremors register—whether at a 1.0 or a 9.0—they’re all earthquakes. Some make the six o’clock news while others don’t disturb our slumber, but these earthquakes are happening every day, every hour, all over the world.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In this way, we plot revivals on a chart of ranging magnitude, indicating their breadth and depth of impact on a 1-5 scale:")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Level one: Personal revivals"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-046",
      "id": "ap_ntf-046-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(".")])]), _vm._v(" At this level, the revival dynamic is localized to an individual. Renewed intimacy with God, where heart and mind are electrified by the nearness of his presence, is the burning center of the moment. Scripture, prayer, and worship come alive with holy expectancy. With this newfound intimacy with God, new light is cast on the assumptions and paradigms of the day. As a result, questions around topics left untouched by the prevailing church culture rise to the surface for biblical "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("engagement, such as the nature of the gospel, the experimentation with the gifts of the Spirit, or the need for social reform and engagement with the marginalized and neglected.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-009"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 2. Levels of revival",
      "src": "images/fig_2.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 2.")]), _vm._v(" Levels of revival")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Level two: Communal revivals.")])]), _vm._v(" The influence of the personal revival begins to spread to the larger community, permeating the broader network of relationships with a small group, campus fellowship, local church, school, business, or other organization. Or perhaps the revival starts here because a group of people experienced a move of God together. At this level, enthusiasm is growing, but so is apprehension. At the personal level, other people choose whether to participate. But as the revival dynamic engages the broader community, it becomes unavoidable for those who are uncomfortable with the changes in the status quo. Wise and humble leadership at this stage is critical to mitigate division and distrust.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_c('b', [_c('i', [_vm._v("Level three: Regional revivals.")])]), _vm._v(" Revival starts to transform a city or region across denominational, racial, and socioeconomic boundaries. Word of mouth spreads awareness of this new thing well beyond the point of conception. As more people catch the wind of inspiration generated by the movement, new voices are added to the mix, some for the better and some for the worse, and the movement either grows through the synergy or dissipates from the confusion. Every revival movement, as a challenge to the status quo, is marked by some level of controversy. But at this stage, tensions reach critical levels because heresy and confusion find their greatest opportunity. Many have a knee-jerk, defensive reaction against this new work of God.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Level four: National revivals.")])]), _vm._v(" The dynamics of the local revival spread across the country, affecting society at institutional and systemic levels. The impact on individual lives disrupts entrenched cultural paradigms and practices. Cultural norms begin to be upended, and societal injustices start to be addressed. Media outlets begin to report on movements at this level, fueling debate and discussion.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Level five: Global revivals.")])]), _vm._v(" This level is closely aligned with the previous one. When a revival reaches national magnitude, it tends also to have a ripple effect globally. It quickly moves beyond national boundaries, as people come to witness the revival, or others are sent to share the message.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In 1738, John Wesley, having failed in his mission to the American South, sailed back to England with uncertainty about his calling and doubts about his relationship with God. After a series of heart-searching meetings with Moravian leader Peter Boehler, he made his way to Aldersgate Street. There, a personal breakthrough sparked a level-one revival in the plowed soil of Wesley’s soul:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("In the evening, I went"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-047",
      "id": "ap_ntf-047-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" very unwillingly to a society in Aldersgate Street, where one was reading Luther’s preface to the Epistle to the Romans. About a quarter before nine, while he was describing the change which God works in the heart through faith in Christ, I felt my heart strangely warmed. I felt I did trust in Christ, Christ alone for salvation, and an assurance was given me that he had taken away my sins, even mine, and saved me from the law of sin and death.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The impact of this moment, though profoundly personal, would not remain private. Inspired by the example of the Moravian prayer vigil, Wesley gathered others, including his brother Charles Wesley and George Whitefield, to commit themselves to seeking God for a greater outpouring of the Spirit. On January 1, 1739, eight months after Wesley’s Aldersgate encounter, a level-two revival ignited as more than sixty people in Wesley’s network of relationships felt their hearts warmed as well: “About three in the morning"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-048",
      "id": "ap_ntf-048-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(", as we were continuing instant in prayer, the power of God came mightily upon us, insomuch that many cried out for exceeding joy, and many fell to the ground.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Within weeks of this prayer meeting, the revival expanded to level three when George Whitefield led a preaching campaign in Bristol. Although it started small, it quickly exploded to crowds of thousands. Within four days, over ten thousand people crowded in daily to hear Whitefield’s open-air preaching. Before long, he brought in John Wesley to help, and in the rush of excitement, boldly predicted, “The fire is kindled"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-049",
      "id": "ap_ntf-049-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" in the country; and I know, all the devils in hell shall not be able to quench it.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Testimonies spread through word of mouth, inspiring others to take up the call to spread the fire. Wesley and the Methodists "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("escalated the revival to a level-four national phenomenon. Whitefield was a fantastic preacher, but John Wesley’s organizational skill conserved the revival’s wild energy from dissipating and being lost. Organizing people into bands, classes, and societies to disciple new believers channeled the revival into the untouched relational networks of the newly converted.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As the level-four revival went on, its impact on English society was dramatic. John Wesley encouraged Christians to seek social reform. He personally gave away all his writing profits to the poor. He spoke out vehemently against the slave trade and encouraged William Wilberforce in his antislavery efforts. And the Methodists and other Christian communities continued to serve others in exceptional ways. In describing their impact, the historian Diane Severance writes:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Numerous agencies promoting Christian work arose as a result of the eighteenth-century revival in England. Antislavery societies, prison reform groups, and relief agencies for the poor were started. Numerous missionary societies were formed; the Religious Tract Society was organized; and the British Foreign Bible Society was established. Hospitals and schools multiplied. The revival cut across denominational lines and touched every class of society. England itself was transformed"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-050",
      "id": "ap_ntf-050-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" by the revival.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It didn’t stop there. Refusing to be quenched by the miles of ocean waters, the revival crossed the Atlantic and set North America ablaze as well. Like a burning ember, Whitefield joined what God was already doing through many others such as William Tennent and Jonathan Edwards, and continued to spark revival after revival in almost every town he visited. The First Great Awakening matured to a level-five global awakening.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Revival and the Kingdom of God")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Where revivals break through, so does the kingdom of God. In the Gospels, Jesus proclaimed that the kingdom of God was near"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-051",
      "id": "ap_ntf-051-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(". It’s where God’s will is fulfilled on earth, where heaven breaks through, and all of its resources are available to us. It’s where what God wants to happen, actually happens. This breakthrough is not something we can force or schedule, but it’s glorious when it shows up. And revivals are one of the most visible ways where the kingdom of God is made evident.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Revivals are an obvious expression of heaven touching earth.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jesus taught us to pray, “Your kingdom come"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-052",
      "id": "ap_ntf-052-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(", your will be done, on earth as it is in heaven.” In teaching us to pray in this way, Jesus gave us the seed of a much larger reality. Thoughts and prayers always have within them a potential to escalate into so much more, if they are given a chance to mature and be lived out. Perhaps this is something of what Jesus was hinting at when he talked about the kingdom of God being like a mustard seed"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-053",
      "id": "ap_ntf-053-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v("—something that is small at first but can eventually grow into something so much bigger.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And he lived it out. Jesus lived a revived life. More than anyone before or after him. He declared that in his single life, the kingdom of God had come near. Jesus, the king, was present. Something much bigger had begun.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Heaven broke through.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And from one life, a moment on the cross transformed into a movement of shalom and salvation that encompassed the entire world. Seasons of breakthroughs—in word, deed, and power—created a new normal, and the world has never been the same.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Discussion Questions")]), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" What part of the definition of revival stood out to you? Why?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("If you were to place a dot that best represents your faith expression on "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#fig-001"
    }
  }, [_vm._v("Figure 1")]), _vm._v(", “The full proclamation of the gospel,” where would you put yourself? In what ways is God inviting you more to the center?")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" What level of revival have you been a part of? What was that like?")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 72
// module chunks = 0